<button
  class="w-full md:w-64 bg-white shadow-lg p-4 rounded-md focus:outline-none text-left sm:hidden flex"
  (click)="toggleCollapse()"
>
  Perfil @if (isHidenCollapse()) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#000000"
  >
    <path d="M480-360 280-560h400L480-360Z" />
  </svg>
  } @if (!isHidenCollapse()) {
  <svg
    xmlns="http://www.w3.org/2000/svg"
    height="24px"
    viewBox="0 -960 960 960"
    width="24px"
    fill="#000000"
  >
    <path d="m280-400 200-200 200 200H280Z" />
  </svg>
  }
</button>

<div
  id="collapse-content"
  class="w-full md:w-64 bg-white shadow-lg rounded-lg p-4 md:min-h-[calc(100vh-5rem)] md:mr-6 hidden sm:block"
>
  <nav class="space-y-2">
    <a
    data-tour="profile-account"
      routerLink="/auth/perfil"
      [routerLinkActive]="['bg-yellow-100']"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex items-center space-x-3 p-3 rounded-lg hover:bg-yellow-50 transition-colors"
    >
      <i class="fas fa-user text-yellow-600"></i>
      <span>Cuenta</span>
    </a>
    <a
    data-tour="profile-payments"
      routerLink="/auth/perfil/payments"
      [routerLinkActive]="['bg-yellow-100']"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex items-center space-x-3 p-3 rounded-lg hover:bg-yellow-50 transition-colors"
    >
      <i class="fas fa-credit-card text-yellow-600"></i>
      <span>Pagos</span>
    </a>
    <a
      data-tour="profile-favorites"
      routerLink="/auth/perfil/favorites-establishment"
      [routerLinkActive]="['bg-yellow-100']"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex items-center space-x-3 p-3 rounded-lg hover:bg-yellow-50 transition-colors"
    >
      <i class="fas fa-heart text-yellow-600"></i>
      <span>Favoritos</span>
    </a>
    <a
    data-tour="profile-devoluciones"
      routerLink="/auth/perfil/devoluciones"
      [routerLinkActive]="['bg-yellow-100']"
      [routerLinkActiveOptions]="{ exact: true }"
      class="flex items-center space-x-3 p-3 rounded-lg hover:bg-yellow-50 transition-colors"
    >
      <i class="fas fa-undo-alt text-yellow-600"></i>
      <span>Devoluciones</span>
    </a>
    <a
      data-tour="profile-recargos"
      routerLink="/auth/perfil/recargos"
      [routerLinkActive]="['bg-yellow-100']"
      [routerLinkActiveOptions]="{ exact: false }"
      class="flex items-center space-x-3 p-3 rounded-lg hover:bg-yellow-50 transition-colors"
    >
      <i class="fas fa-hand-holding-usd text-yellow-600"></i>
      <span>Recargos</span>
    </a>
  </nav>
</div>
